<template lang="html">
  <div class="footer">
    <div class="max-width">
      <span>Footer</span>
    </div>
  </div>
</template>

<script>
export default {
}
</script>



// WEBPACK FOOTER //
// src/components/layout/footer.vue